module.exports = __webpack_public_path__ + "media/images/yt-e520cb0d.svg";